import request from '@/utils/request'

export const selectList = (data) => {
  return request({
    url: '/manage/dp/selectList',
    method: 'get',
    data,
  })
}
export const selectSubList = (params) => {
  return request({
    url: '/manage/dp/selectSubList',
    method: 'get',
    params,
  })
}
export const projectList = (data) => {
  return request({
    url: '/manage/dp/projectList',
    method: 'post',
    data,
  })
}
export const projectDetail = (data) => {
  return request({
    url: '/manage/dp/projectDetail',
    method: 'post',
    data,
  })
}
export const projectEvaList = (data) => {
  return request({
    url: '/manage/dp/projectEvaList',
    method: 'post',
    data,
  })
}
export const comment = (data) => {
  return request({
    url: '/manage/dp/comment',
    method: 'post',
    data,
  })
}
export const reply = (data) => {
  return request({
    url: '/manage/dp/reply',
    method: 'post',
    data,
  })
}
export const my = (data) => {
  return request({
    url: '/manage/dp/my',
    method: 'post',
    data,
  })
}
export const myEvaList = (data) => {
  return request({
    url: '/manage/dp/myEvaList',
    method: 'post',
    data,
  })
}
export const myReplyList = (data) => {
  return request({
    url: '/manage/dp/myReplyList',
    method: 'post',
    data,
  })
}

export const deleteEva = (data) => {
  return request({
    url: '/manage/dp/deleteEva',
    method: 'post',
    data,
  })
}
